<script setup lang="ts">
import { Bell } from 'lucide-vue-next';
import { computed, watch } from 'vue';
import { useApi, useRoute } from '@/runtime';
const route = useRoute();
const { data, refresh } = useApi<{ unreadCount: number }>('/api/notifications/unread', {
  key: 'notifications-unread', default: () => ({ unreadCount: 0 }),
});
const count = computed(() => data.value?.unreadCount ?? 0);
watch(() => route.path, () => { void refresh(); });
</script>

<template>
  <RouterLink to="/notifications" class="icon-button notification-bell press" :aria-label="count ? `Уведомления, непрочитанных: ${count}` : 'Уведомления'" title="Уведомления">
    <Bell :size="20" :stroke-width="1.7" aria-hidden="true" />
    <span v-if="count" class="notification-count" aria-hidden="true">{{ count > 99 ? '99+' : count }}</span>
  </RouterLink>
</template>
